import { useCallback } from 'react';

import { useSafeNavigation, useSafeRouter } from '@sg/garnish';

import { useIsExpoRouterEnabled } from '@order/shared/hooks';

/**
 * Goes back within the stack if possible, otherwise goes back to the main stack.
 */
export const useNavigateBack = () => {
  const isExpoRouterEnabled = useIsExpoRouterEnabled();
  const router = useSafeRouter();
  const navigation = useSafeNavigation();

  return useCallback(() => {
    if (isExpoRouterEnabled) {
      try {
        requestIdleCallback(() => {
          if (router?.canGoBack()) {
            router?.back();

            return;
          }

          router?.dismissTo('/');
        });
      } catch {
        // expo-router throws if called before Root Layout mounts
      }

      return;
    }

    if (navigation?.canGoBack()) {
      navigation.goBack();

      return;
    }

    navigation?.getParent()?.goBack();
  }, [isExpoRouterEnabled, router, navigation]);
};
